<template>
    <div class="headline">
        <div class="headline-en">{{titleObj.en}}</div>
        <hr class="hr">
        <div class="headline-ch">{{titleObj.ch}}</div>
    </div>
</template>

<script>
    export default {
        name: 'ItemTitle',
        props: {
            titleObj: {
                type: Object
            }
        },
        data() {
            return {}
        }
    }
</script>
